import { useFieldArray, useForm } from "react-hook-form";
import * as yup from "yup";

import { WorkspaceInviteInputs } from "@app/analytics/account/WorkspaceSettings/WorkspaceWizard/types";
import { yupResolver } from "@app/utils/forms/yupResolver";

export const WORKSPACE_INVITE_FIELD_ARRAY_NAME = "users";
export const DEFAULT_WORKSPACE_INVITE_INPUT: WorkspaceInviteInputs = {
  email: "",
  team: "",
  role: "member",
};

const inviteValidationSchema = yup.object().shape({
  users: yup.array().of(
    yup.object().shape({
      email: yup.string().email("Must be a valid email"),
      team: yup.string(),
      role: yup.string(),
    })
  ),
});

const useInviteWorkspaceMembersForm = () => {
  const form = useForm({
    resolver: yupResolver(inviteValidationSchema),
    defaultValues: {
      [WORKSPACE_INVITE_FIELD_ARRAY_NAME]: [DEFAULT_WORKSPACE_INVITE_INPUT],
    },
  });

  const fieldArray = useFieldArray({
    control: form.control,
    name: WORKSPACE_INVITE_FIELD_ARRAY_NAME,
  });

  return { form, fieldArray };
};

export default useInviteWorkspaceMembersForm;
